<template>
  <div class="mdl-card mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--6-col-phone"
        :data-i="i"
        :data-index="index"
        :data-value="data.id"
        :data-text="data.nombre"
        :data-father-id="data.padreId"
        :data-photo="data.imagen"
        @click="clickEvent">
    <div class="mdl-card__media mdl-color-text--grey-50"
          :style="'background-image:url(' + data.imagen + ')'">
      <!-- <h3><a href="entry.html">Coffee Pic</a></h3> -->
      <!-- <img :src="asset.photo" alt="Logo representativo"> -->
    </div>
    <div class="mdl-card__supporting-text meta mdl-color-text--grey-600">
      <!-- <div class="minilogo"></div> -->
      <div>
        <strong>{{ data.nombre }}</strong>
        <span>{{ data.hijosTotal + ' ' + data.hijosNombre }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['i', 'data', 'index', 'clickEvent'],
  data () {
    return {

    }
  },
  methods: {
    clicked () {
      console.log('hi hi');
    }
  },
  mounted () {
    this.$emit('showActionbar', false)
  }
}
</script>

<style lang="css" scoped>
  .mdl-card {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    min-height: 360px;
    cursor: pointer;
  }

  .mdl-card .mdl-card__media {
    box-sizing: border-box;
    background-color: #fff;
    background-size: cover;
    background-position-x: 100%;
    padding: 24px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: flex-end;
    -ms-flex-align: end;
    align-items: flex-end;
  }

  .mdl-card .mdl-card__media h3 {
    margin: 0;
  }

  .mdl-card .mdl-card__media h3 a {
    text-decoration: none;
  }

  .mdl-card .mdl-card__supporting-text {
    width: 100%;
    min-height: 64px;
    padding: 16px;
    min-height: 64px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .mdl-card .mdl-card__supporting-text > * {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .mdl-card .mdl-card__supporting-text .minilogo {
    width: 44px;
    height: 44px;
    margin-right: 16px;
    /*background-image: url(profile-64.png);*/
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50%;
    border-radius: 22px;
    background-color: #F5F5F5;
  }
</style>


// WEBPACK FOOTER //
// Card.vue?46f48522